import React from 'react';
import { useField } from 'formik';

import Quill from './quill/Quill.jsx';

const FieldQuill = (props) => {
  const [, { value }, { setTouched, setValue }] = useField(props);

  return (
    <Quill
      value={value}
      onBlur={setTouched}
      onChange={setValue}
      {...props}
    />
  );
};

export default FieldQuill;
